import React, { useState } from 'react';
import { Text, useColorModeValue } from '@chakra-ui/react';
import AsyncCreatable from 'react-select/async-creatable';

export const CustomCreatableSelect = React.forwardRef((props, ref) => {
  const [inputValue, setInputValue] = useState('');

  // Filter out options with empty labels
  const filteredOptions = props.options.filter((option) => option.label !== '');

  const modePlaceholderColor = useColorModeValue(
    'rgba(59, 72, 81, 0.6)',
    props.liveEventData ? '#ddd' : '#7F8488'
  );
  const modeMenuBg = useColorModeValue('#fff', '#2F343D');
  const modeMenuColor = useColorModeValue('#000000', '#fff');
  const modeMenuBgHover = useColorModeValue(
    'rgba(221, 221, 221, 0.5)',
    '#000000'
  );
  const modeMenuColorDisabled = useColorModeValue('#ddd', '#5A6066');
  const modeBorderHover = useColorModeValue('#2F343D', '#fff');

  const reactSelectGroupTagStyles = {
    control: (provided, state) => ({
      ...provided,
      padding: props.padding || '0px 16px',
      display: 'flex',
      borderRadius: '25px',
      border: '2px solid transparent',
      boxShadow: 'none',
      ':hover': {
        borderColor: modeBorderHover,
        transition: 'all .3s ease-in-out',
        cursor: 'pointer',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? modeMenuColorDisabled : modeMenuColor,
      backgroundColor: modeMenuBg,
      ':hover': {
        backgroundColor: state.isDisabled ? 'none' : modeMenuBgHover,
        color: state.isDisabled ? 'none' : modeMenuColor,
      },
    }),
    menu: (provided, state) => ({
      ...provided,
    }),
    menuList: (provided, state) => ({
      ...provided,
      padding: '0px',
      zIndex: '5',
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: modePlaceholderColor,
      fontSize: '14px',
    }),
    clearIndicator: (provided, state) => ({
      ...provided,
      color: modeMenuColor,
      ':hover': {
        color: modeMenuColor,
        cursor: 'pointer',
      },
      svg: {
        width: '1em',
        height: '1em',
      },
    }),
    indicatorSeparator: (provided, state) => ({
      display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      paddingRight: '0px',
      color: modeMenuColor,
      ':hover': {
        color: modeMenuColor,
        cursor: 'pointer',
      },
      svg: {
        width: '1em',
        height: '1em',
      },
    }),
    multiValue: (provided, state) => ({
      ...provided,
      color: '#2F343D',
      backgroundColor: '#DDDD',
      borderRadius: '25px',
      padding: '0px 5px',
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      color: '#2F343D',
      ':hover': {
        color: '#2F343D',
      },
    }),
  };

  const handleInputChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'input-change') {
      setInputValue(newValue);
    }
  };

  const formatOptionLabel = ({ label }) => {
    if (label === '') {
      return null;
    }

    if (!label) {
      return <Text fontSize="14px">Create tag "{inputValue}"</Text>;
    }

    return <Text fontSize="14px">{label}</Text>;
  };

  return (
    <AsyncCreatable
      isClearable
      {...props}
      defaultOptions={filteredOptions}
      ref={ref}
      styles={reactSelectGroupTagStyles}
      formatOptionLabel={formatOptionLabel}
      onInputChange={handleInputChange}
    />
  );
});
